import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Textarea,
} from '@/components/TailwindComponents';
import { useBookingStore } from '@/pages/JMS/store/BookingStore';
import { useToastStore } from '@/store';

export const DeleteBookingDialog = () => {
  const [reason, setReason] = useState('');
  const { booking, deleteBookingData, deleteBooking } = useBookingStore();
  const { updateToast } = useToastStore();
  const { isModalOpen } = deleteBookingData || { isModalOpen: false };
  const navigate = useNavigate();

  const handleDeleteBooking = () => {
    if (!reason.trim()) return;
    deleteBooking({ reason, isModalOpen: false, navigate, updateToast });
    setReason('');
  };

  const handleCancel = () => {
    deleteBooking({ reason: '', isModalOpen: false });
    setReason('');
  };

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(isOpen) => !isOpen && handleCancel()}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            Are you sure you want to delete the booking{' '}
            {booking?.details?.number}?
          </DialogTitle>
          <DialogDescription>
            Add reason for deleting the booking (required)
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for deletion..."
            className="w-full resize-none"
            rows={4}
          />
        </div>
        <DialogFooter className="justify-end">
          <button
            onClick={handleCancel}
            className="mt-2 sm:mt-0 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium bg-white text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleDeleteBooking}
            disabled={!reason.trim()}
            className={`px-4 py-2 rounded-md text-sm font-medium ${
              reason.trim()
                ? 'bg-red-600 text-white hover:bg-red-700'
                : 'bg-red-300 text-white cursor-not-allowed'
            }`}
          >
            Delete Booking
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
